/**
 * 增强模式(步骤)
 */

import React, { useEffect, useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/helper';
import { SVGPureIcon } from '@/ui';
import EnhanceStore from './store';
import appLogger from '@public/log/monitor';
import "./index.scss";
import { getModelCategory } from '@shared/store/chat';
import Conf from '@/common/conf';

// 用于显示打点
const Tips = observer((props) => {
  // const {
  //   messageId,
  // } = useMessageContext();
  // const {
  //   tips,
  //   folded,
  // } = props;
  // const search_keyword_total = tips?.length || 0;

  // useEffect(() => {
  //   if(tips?.length){
  //     const extList = {};
  //     tips.forEach((item, index) => {
  //       extList[`ext${index + 1}`] = item.content;
  //     });
  //   }
  // }, [messageId, search_keyword_total]);

  return null;
});

const Enhance = observer((props) => {
  const {
    type = "flow",          // flow: 工作流步骤
    folded = false,         // 是否折叠(工作流步骤)
    flows,                  // 工作流步骤
    className = '',
    containerClassName = '',
    isCompleted = false,    // 消息已结束
    chatStore,
    asstInfo,               // 模型信息
    messageItem,
  } = props;

  const store = useLocalObservable(() => new EnhanceStore({ type }));
  const [secondUnfolded, setSecondUnfolded] = useState(false)
  useEffect(() => {
    store.updateData({ type });
  }, [type]);
  useEffect(() => {
    store.updateData({ isFolded: folded });
  }, [folded]);
  useEffect(() => {
    store.updateData({ flows });
  }, [flows]);
  const modelCategory = useMemo(() => {
    return getModelCategory(messageItem);
  }, [messageItem]);

  const flowOver = isCompleted || (store.flows || []).find(item => item.isResult); // 工作流步骤是否已完成

  const enhanceTitle = useMemo(() => {
    if(flows?.search_total){
      return `找到 ${flows.refer_search?.length || 0} 篇资料作为参考`;
    }

    return "AI智能处理中";
  }, [flows]);

  // 直接走大模型，没走猜词，参考
  if((isCompleted || folded) && !flows?.refer_search?.length){
    return null;
  }

  // debug
  // console.log(`Enhance data:`, HelperCore.copyObj(messageItem), messageItem.role_id, Conf.roleIds.assistant, messageItem?.role_id != Conf.roleIds.assistant);

  return (
    <div className={`${store.isFolded ? 'w-480px' : 'w-full'} pb-16px pt-8px ${containerClassName}`}>
      <div
        className={`w-full rounded-[12px] px-[12px] py-[12px] bg-secondary relative ${store.isFolded ? 'hover:bg-gray-nav-hover' : ''} ${className}`}
        >
        <div
          className={`w-full flex h-[20px] items-center justify-between ${store.supportFold && store.isFolded ? "cursor-pointer" : ""}`}
          onClick={
            () => {
              if(!store.supportFold){
                return;
              }
              if(!store.isFolded){
                return;
              }
              store.toggleFolded();
              setSecondUnfolded(false)
            }
          }>
          <div className="text-[14px] text-primary flex items-center w-0 flex-grow relative">
            {
              messageItem?.role_id == Conf.roleIds.assistant && asstInfo
              ? (
                isCompleted
                ? (
                  <>
                    <div className={`flex items-center pr-12px h-20px w-0 flex-grow`}>
                      <div className="flex items-center h-full">
                        <img src={asstInfo.icon} className='w-16px h-16px rounded-4px mr-6px' />
                        <div className="text-primary font-bold text-14px">{asstInfo.title}</div>
                      </div>
                      <div className="ml-4px text-primary-opacity text-14px text-opacity-50">
                        { modelCategory || "" }
                      </div>
                    </div>
                    {
                      store.isFolded
                      ? (
                        <div className='select-none text-primary-opacity text-opacity-50 pr-12px font-normal text-14px'>{store.flows.length}步已完成</div>
                      )
                      : null
                    }
                  </>
                )
                : (
                  <>
                  <div className={`flex items-center pr-12px h-20px w-0 flex-grow`}>
                    <div className="flex items-center h-full w-0 flex-grow">
                      <img src={asstInfo.icon} className='w-16px h-16px rounded-4px mr-6px' />
                      <div className="text-primary-opacity font-bold text-14px">{asstInfo.title}</div>
                    </div>
                    <div className="ml-4px text-primary-opacity text-14px text-opacity-50">
                      { modelCategory || "回答中" }
                    </div>
                  </div>
                </>
                )
              )
              : (
                <>
                  <SVGPureIcon className="w-[20px] h-[20px]" name="comp-xing"></SVGPureIcon>
                  <div className='ml-[8px] w-0 flex-grow truncate'>{enhanceTitle}</div>
                  {
                    store.isFolded
                    ? (
                      <div className='select-none text-primary-opacity text-opacity-50 pr-12px font-normal text-14px'>{store.flows.length}步已完成</div>
                    )
                    : null
                  }
                </>
              )
            }
          </div>
          {
            store.supportFold
            ? (
              <div
                className={`size-16px flex items-center justify-center cursor-pointer transition-transform transition-[0.25s] transform ${!store.isFolded ? '!size-24px hover:bg-primary-opacity hover:bg-opacity-5 rounded-full' : 'rotate-[180deg] translate-y-1px'}`}
                onClick={
                  (event) => {
                    if(!store.supportFold){
                      return;
                    }
                    if(store.isFolded){
                      return;
                    }

                    event.stopPropagation();
                    store.toggleFolded();
                    setSecondUnfolded(false)
                  }
                }
                >
                <SVGPureIcon className="w-[12px] h-[7px] opacity-70 text-primary-opacity" name="enh-fold">
                </SVGPureIcon>
              </div>
            )
            : null
          }
        </div>

        <div className={`w-full flex mt-[20px] text-left text-primary-opacity text-opacity-80 text-[12px] leading-[17px] ${store.isFolded ? "hidden" : ""}`}>
          <div className='w-full'>
            {
              store.flows.map((item, index) => {
                const isLast = index == store.flows.length - 1;
                const isLoading = isLast && !flowOver;
                const hasTips = item.tips?.length;
                const isRefer = item.isRefer && item.list?.length;

                return (
                  <div
                    className=''
                    key={index}
                    >
                    <div className={`flex w-full text-14px ${isLast && !hasTips && !isRefer ? "mb-0px" : hasTips || isRefer ? "mb-[12px]" : "mb-[16px]"}`}>
                      {
                        isLoading
                        ? <SVGPureIcon className='ani-rotate animate-ease-in-out w-[20px] h-[20px]' name="enh-loading"></SVGPureIcon>
                        : <SVGPureIcon className='w-[20px] h-[20px]' name="enh-right"></SVGPureIcon>
                      }
                      <div className="w-0 flex-grow ml-[8px] leading-[20px]">
                        <div className="" dangerouslySetInnerHTML={{ __html : HelperCore.xss(item.text) }}></div>
                      </div>
                    </div>
                    {
                      // 参考资料多一个节点？
                      !isLoading && isRefer
                      ? (
                        <div className={`flex w-full text-14px mb-[12px]`}>
                          <SVGPureIcon className='w-[20px] h-[20px]' name="enh-search"></SVGPureIcon>
                          <div className="w-0 flex-grow ml-[8px] leading-[20px]">
                            <div className="">参考资料</div>
                          </div>
                        </div>
                      )
                      : null
                    }
                    {
                      hasTips
                      ? (
                        <div className="pb-[8px] pl-[24px] flex flex-wrap">
                          <Tips key="tip_logger" tips={item.tips} folded={store.isFolded} />
                          {
                            item.tips.map((item, index) => {
                              return (
                                <div
                                  key={`${item.content}_${index}`}
                                  onClick={
                                    () => {
                                      chatStore.sendMessage({
                                        input : item.content,
                                      });
                                      appLogger.log({
                                        key: "aibot_chat",
                                        action: 'click',
                                        arrt: 'chat_keyword',
                                        ext: item.content
                                      });
                                    }
                                  }
                                  className="mr-[8px] mb-[8px] px-[12px] h-[24px] leading-[24px] text-[12px] text-primary-opacity text-opacity-90 rounded-[6px] bg-enh-keyword hover:bg-enh-keyword-hover hover:font-bold cursor-pointer truncate">
                                  {item.content}
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                      : null
                    }
                    {
                      isRefer
                      ? (
                        <div className="ml-[26px]  bg-enh-referer text-left rounded-[12px] p-[12px] text-[12px] leading-[17px]">
                          {/* 最多展示10条, 没有再次折叠逻辑 */}
                          {
                            (secondUnfolded ? (item.list): item.list.slice(0,10)).map((site, index) => {
                              return (
                                <div
                                  key={site.title + index}
                                  className='mb-[14px]'
                                  onClick={() => {
                                    appLogger.log({
                                      key: "aibot_chat",
                                      action: 'click',
                                      arrt: 'chat_site',
                                      ext: site.title,
                                      ext1: site.url
                                    });
                                  }}
                                >
                                  <a
                                    target='_blank'
                                    href={site.url}
                                    className='!text-active break-all inline-block hover:font-bold !hover:underline'
                                    dangerouslySetInnerHTML={{ __html : `${index+1}. ${HelperCore.xss(site.title)}` }}
                                    >
                                  </a>
                                  {
                                    site.site
                                    ? (
                                      <span className="text-primary-opacity text-opacity-50 inline-block pl-4px">{site.site}</span>
                                    )
                                    : null
                                  }
                                  {
                                    site.date
                                    ? (
                                      <span className="text-primary-opacity text-opacity-50 inline-block pl-4px">[{site.date}]</span>
                                    )
                                    : null
                                  }
                                </div>
                              )
                            })
                          }
                          {item.list.length > 10 && !secondUnfolded ? <div className='w-full leading-17px text-12px pb-12px pt-2px flex justify-center items-center gap-[5px] opacity-50 hover:opacity-80 hover:font-bold cursor-pointer select-none' onClick={()=>{setSecondUnfolded(true)}}>展开全部<SVGPureIcon className="w-9px h-8px" name="icon_double_down"></SVGPureIcon></div>:null}
                        </div>
                      )
                      : null
                    }
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
});
export default Enhance;